import { render, staticRenderFns } from "./InlandVesselPracticeUpsertForm.vue?vue&type=template&id=1e04dccc"
import script from "./InlandVesselPracticeUpsertForm.vue?vue&type=script&lang=ts"
export * from "./InlandVesselPracticeUpsertForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports